var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 323.6 302",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1.84 .5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m305.19 0-125.88 94.09 23.28-55.51z",
    fill: "#e2761b",
    stroke: "#e2761b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e4761b",
    stroke: "#e4761b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.6 0 124.86 95-22.14-56.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.9 218.11-33.53 51.69 71.74 19.87 20.62-70.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.31 219.26 20.5 70.41 71.73-19.87-33.54-51.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.49 130.76-20 30.44 71.23 3.18-2.53-77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.3 130.76-49.3-44.31-1.65 77.93 71.1-3.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.54 269.8 42.76-21-36.94-29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.49 248.8 42.88 21-5.94-50z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m226.37 269.8-42.88-21 3.41 28.14-.38 11.84z",
    fill: "#d7c1b3",
    stroke: "#d7c1b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.54 269.8 39.85 19-.25-11.84 3.16-28.14z",
    fill: "#d7c1b3",
    stroke: "#d7c1b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134 201.18-35.65-10.57 25.17-11.61z",
    fill: "#233447",
    stroke: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.76 201.18 10.51-22.18 25.3 11.59z",
    fill: "#233447",
    stroke: "#233447"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#cd6116",
    stroke: "#cd6116"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m93.54 269.8 6.07-51.69-39.61 1.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.3 218.11 6.07 51.69 33.53-50.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.41 161.2-71.1 3.18 6.58 36.8 10.5-22.18 25.3 11.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.35 190.61 25.3-11.61 10.35 22.18 6.71-36.8-71.21-3.18z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m69.5 161.2 29.86 58.57-1-29.16z",
    fill: "#e4751f",
    stroke: "#e4751f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.69 190.61-1.26 29.16 30-58.57z",
    fill: "#e4751f",
    stroke: "#e4751f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.73 164.38-6.73 36.8 8.35 43.41 1.9-57.17z",
    fill: "#e4751f",
    stroke: "#e4751f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.31 164.38-3.41 22.92 1.52 57.29 8.47-43.41z",
    fill: "#e4751f",
    stroke: "#e4751f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.89 201.18-8.47 43.41 6.07 4.21 36.94-29 1.26-29.16z",
    fill: "#f6851b",
    stroke: "#f6851b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.35 190.61 1 29.16 36.94 29 6.07-4.21-8.36-43.38z",
    fill: "#f6851b",
    stroke: "#f6851b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.52 288.78.38-11.84-3.16-2.81h-47.69l-2.91 2.81.25 11.84-39.85-19 13.92 11.46 28.21 19.76h48.45l28.34-19.74 13.91-11.46z",
    fill: "#c0ad9e",
    stroke: "#c0ad9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.49 248.8-6.07-4.21h-35l-6.07 4.21-3.16 28.14 2.91-2.81h47.69l3.16 2.81z",
    fill: "#161616",
    stroke: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.5 100.21 10.76-51.95-16.07-48.26-121.7 90.91 46.81 39.85 66.16 19.49 14.68-17.19-6.33-4.59 10.12-9.29-7.84-6.11 10.12-7.77z",
    fill: "#763d16",
    stroke: "#763d16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1.34 48.26 10.75 52-6.83 5.04 10.12 7.77-7.7 6.11 10.12 9.29-6.32 4.59 14.55 17.19 66.16-19.49 46.79-39.85-121.7-90.91z",
    fill: "#763d16",
    stroke: "#763d16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.46 150.25-66.16-19.49 20.11 30.44-30 58.57 39.47-.51h58.83z",
    fill: "#f6851b",
    stroke: "#f6851b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.49 130.76-66.16 19.49-22 69h58.67l39.35.51-29.85-58.56z",
    fill: "#f6851b",
    stroke: "#f6851b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.31 164.38 4.18-73.47 19.23-52.33h-85.4l19 52.33 4.43 73.47 1.52 23.17.12 57h35l.25-57z",
    fill: "#f6851b",
    stroke: "#f6851b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.31b75dccdf52ed383f2dcb3385e494ea.svg";
export { ForwardRef as ReactComponent };